import { useNavigate, useParams } from "react-router-dom";
import Header from "../components/Header";
import { useState } from "react";
import Breadcrumbs from "../components/Breadcrumbs";
import DetailedServices from "../assets/images/Detailed_services.png";
import PrimaryButton from "../components/PrimaryButton";
import DoubleTick from "../assets/icons/doubletick.svg";
import Consultation from "../assets/images/consultation.png";
import SponsorImage from "../assets/images/SponsorImage.png";
import FB from "../assets/icons/footer-fb.svg";
import Insta from "../assets/icons/footer-insta.svg";
import Twitter from "../assets/icons/footer-twitter.svg";
import linkdin from "../assets/icons/footer-in.svg";
import phoneIcon from "../assets/images/phoneIcon.svg";
import bulletIcon from "../assets/icons/bulletIcon.svg";
import { ImOpt } from "react-icons/im";
import AppointmentForm from "../components/AppointmentForm";

const servicesList = [
  {
    id: 1,
    title: "Physician Initial Consultation",
    subtitle: "Care in the comfort of your home",
    description:
      "Our licensed physicians provide personalized medical attention without you leaving your house.",
    image: DetailedServices,
    overview: [
      {
        title: "Detailed Health History Review",
        description:
          "Our licensed physician will go through past and current medical records, past diagnoses, surgeries, medications, allergies, and lifestyle factors.",
      },
      {
        title: "Personalized Care Plan Design",
        description:
          "Following the assessment, the physician creates a tailored care roadmap — outlining immediate priorities, ongoing needs, and recommended follow-up appointments.",
      },
      {
        title: "Current Symptom & Concern Discussion",
        description:
          "We take the time to listen — whether it’s a recent change in health, ongoing discomfort, or preventive check-up needs.",
      },
      {
        title: "Medication Review",
        description:
          "We review current prescriptions, over-the-counter medicines, and supplements to ensure there are no conflicts and that treatment is optimal.",
      },
    ],
  },
  {
    id: 2,
    title: "Physician In-Home Visit",
    subtitle: "Your First Step Towards Personalized, World-Class Care",
    description:
      "At VeriMED, every care journey begins with a comprehensive initial consultation...",
    image: DetailedServices,
    overview: [
      {
        title: "Detailed Health History Review",
        description:
          "Our physicians thoroughly assess your medical history to understand your unique health needs.",
      },
      {
        title: "Personalized Care Plan Design",
        description:
          "Based on your history and current needs, we design a care plan tailored specifically for you.",
      },
      {
        title: "Current Symptom & Concern Discussion",
        description:
          "We take the time to understand your symptoms and concerns for a complete evaluation.",
      },
      {
        title: "Medication Review",
        description:
          "We review all your current medications to ensure safe and effective treatment.",
      },
    ],
  },
  {
    id: 3,
    title: "Physician Initial Consultation",
    subtitle: "Expert care from anywhere",
    description:
      "Connect with licensed physicians from the comfort of your home via secure video calls.",
    image: DetailedServices,
    overview: [
      "Secure video consultation",
      "Prescription refills",
      "Follow-up appointments",
    ],
  },
  {
    id: 4,
    title: "Physician Virtual Visit",
    subtitle: "Expert care from anywhere",
    description:
      "Connect with licensed physicians from the comfort of your home via secure video calls.",
    image: DetailedServices,
    overview: [
      "Secure video consultation",
      "Prescription refills",
      "Follow-up appointments",
    ],
  },
  {
    id: 5,
    title: "Skilled Nurse Wellness Check",
    subtitle: "Expert care from anywhere",
    description:
      "Connect with licensed physicians from the comfort of your home via secure video calls.",
    image: DetailedServices,
    overview: [
      "Secure video consultation",
      "Prescription refills",
      "Follow-up appointments",
    ],
  },
  {
    id: 6,
    title: "Skilled Nursing Rehydration",
    subtitle: "Expert care from anywhere",
    description:
      "Connect with licensed physicians from the comfort of your home via secure video calls.",
    image: DetailedServices,
    overview: [
      "Secure video consultation",
      "Prescription refills",
      "Follow-up appointments",
    ],
  },
  {
    id: 7,
    title: "Skilled Nursing Infusion Therapy",
    subtitle: "Expert care from anywhere",
    description:
      "Connect with licensed physicians from the comfort of your home via secure video calls.",
    image: DetailedServices,
    overview: [
      "Secure video consultation",
      "Prescription refills",
      "Follow-up appointments",
    ],
  },
  {
    id: 8,
    title: "Care Management & Navigation",
    subtitle: "Expert care from anywhere",
    description:
      "Connect with licensed physicians from the comfort of your home via secure video calls.",
    image: DetailedServices,
    overview: [
      "Secure video consultation",
      "Prescription refills",
      "Follow-up appointments",
    ],
  },
];

export default function ServiceDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [hovered, setHovered] = useState("about");
  const service = servicesList.find((s) => s.id === parseInt(id));

  const breadcrumbItems = [
    {
      label: "Home",
      active: hovered === "home",
      onClick: () => {},
      onMouseEnter: () => setHovered("home"),
      onMouseLeave: () => setHovered(null),
    },
    {
      label: "Services",
      active: hovered === "services" || hovered === null,
      onClick: () => {},
      onMouseEnter: () => setHovered("services"),
      onMouseLeave: () => setHovered("services"),
    },
  ];

  const socialLinks = [
    { link: "#", icon: FB },
    { link: "#", icon: linkdin },
    { link: "#", icon: Twitter },
    { link: "#", icon: Insta },
  ];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#007f5f0a",
      }}
    >
      <Header />

      {/* hero section */}
      <div
        style={{
          position: "relative",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          minHeight: "100vh",
          marginTop: -45,
        }}
      >
        {/* Breadcrumbs */}
        <div
          style={{
            position: "absolute",
            top: "80px",
            left: "30px",
            zIndex: 1,
          }}
        >
          <Breadcrumbs items={breadcrumbItems} />
        </div>

        {/* Background Image */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100vw",
            minHeight: "80vh",
            zIndex: -2,
          }}
        >
          <div
            style={{
              backgroundColor: "#007F5F14",
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              transition: "opacity 1s ease-in-out",
            }}
          />
        </div>

        {/* Gradient Overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            minHeight: "100vh",
            background: "linear-gradient(180deg, #00000000 , #E5EFEA)",
            zIndex: -1,
          }}
        />

        {/* Hero Content */}
        <div
          style={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            boxSizing: "border-box",
            marginTop: 50,
          }}
        >
          <p
            style={{
              fontSize: 20,
              fontWeight: 500,
              color: "#004E89",
              margin: 0,
            }}
          >
            Services
          </p>
          <h1
            style={{
              color: "#007F5F",
              fontSize: 44,
              fontWeight: "600",
              margin: 0,
              textAlign: "center",
            }}
          >
            {service.title}
          </h1>
          <p
            style={{
              color: "#2E2E2E",
              fontSize: 18,
              margin: "24px 0 32px 0",
              textAlign: "center",
              maxWidth: 600,
              margin: 0,
            }}
          >
            {service.subtitle}{" "}
          </p>
        </div>
      </div>

      {/* detailed section */}

      <div
        style={{
          width: "85%",
          paddingTop: "60px",
          paddingBottom: "60px",
          display: "flex",
          gap: "40px",
        }}
      >
        {/* Left Column */}
        <div
          style={{
            width: "75%",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <div>
            <p
              style={{
                fontSize: 32,
                fontWeight: 600,
                color: "#007F5F",
                margin: 0,
              }}
            >
              {service.title}
            </p>
            <p style={{ fontSize: 16, fontWeight: 400, color: "#2E2E2E" }}>
              Your First Step Towards Personalized, World-Class Care
            </p>
            <img
              src={service.image}
              alt={service.title}
              style={{
                width: "90%",
                height: 360,
                borderRadius: 20,
                objectFit: "cover",
              }}
            />
            <p style={{ fontSize: 24, fontWeight: 600, color: "#2E2E2EE5" }}>
              Overview
            </p>
            <p style={{ fontSize: 16, fontWeight: 400, color: "#2E2E2E" }}>
              At VeriMED, every care journey begins with a comprehensive initial
              consultation. This is more than just a first appointment — it’s
              where we get to know the patient’s health story, needs, and
              preferences so we can design a care plan that’s truly personal.
            </p>
            <p style={{ fontSize: 16, fontWeight: 400, color: "#2E2E2E" }}>
              Whether you’re in Cameroon or sponsoring a parent from abroad,
              this in-person or secure virtual visit ensures we understand every
              detail before care begins.
            </p>
            <div
              style={{
                gridColumn: "span 2",
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              {/* <PrimaryButton
                label="Enroll a Patient"
                onClick={() => {
                  navigate("/membership");
                }}
              /> */}
            </div>
          </div>

          <div>
            <p
              style={{
                fontSize: 32,
                fontWeight: 600,
                color: "#007F5F",
                marginBottom: 20,
              }}
            >
              What’s Included in the Initial Consultation
            </p>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 20,
              }}
            >
              {service.overview.map((item, i) => (
                <div
                  key={i}
                  style={{
                    padding: "20px",
                    borderRadius: "20px",
                    border: "2px solid #035B9D",
                  }}
                >
                  <p
                    style={{ color: "#004E89", fontWeight: 500, fontSize: 18 }}
                  >
                    {i + 1}. {item.title}
                  </p>
                  <p style={{ color: "#2E2E2E", fontSize: 14 }}>
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "40px",
              alignItems: "start",
              marginTop: "60px",
              width: "100%",
            }}
          >
            {/* Left Column (Text + Checklist) */}
            <div>
              <p
                style={{
                  fontSize: 32,
                  fontWeight: 600,
                  color: "#007F5F",
                  margin: 0,
                }}
              >
                Why the Initial Consultation Matters
              </p>
              <p
                style={{
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#2E2E2E",
                  marginBottom: "20px",
                }}
              >
                Laying the foundation for safe, personalized, and effective care
              </p>

              {/* Checklist in 2 columns */}
              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr", // two columns
                  gap: "12px 20px", // row-gap and column-gap
                }}
              >
                {[
                  "Builds Trust",
                  "Guides Care",
                  "Resolves Concerns",
                  "Holistic View",
                  "Sets Priorities",
                  "Engages Family",
                ].map((item, index) => (
                  <li
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: 16,
                      fontWeight: 400,
                      color: "#2E2E2E",
                    }}
                  >
                    <img
                      src={DoubleTick}
                      alt="check"
                      style={{
                        width: "22px",
                        height: "22px",
                        marginRight: "12px",
                        flexShrink: 0,
                      }}
                    />
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            {/* Right Column (Image) */}
            <div>
              <img
                src={Consultation}
                alt="Consultation"
                style={{
                  width: "100%",
                  height: 286,
                  borderRadius: "12px",
                  objectFit: "cover",
                }}
              />
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "40px",
              marginTop: "60px",
            }}
          >
            <div>
              <p
                style={{
                  fontSize: 28,
                  fontWeight: 600,
                  color: "#007F5F",
                  margin: 0,
                }}
              >
                For Sponsors Abroad
              </p>
              <p
                style={{
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#2E2E2E",
                  marginBottom: "20px",
                }}
              >
                Even if you’re thousands of miles away, you can join the initial
                consultation virtually. This allows you to:
              </p>

              {/* Bullet List */}
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {[
                  "Ask the physician questions in real time.",
                  "Understand the care plan being developed.",
                  "Stay involved in your parent’s healthcare decisions.",
                ].map((item, index) => (
                  <li
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "10px",
                      fontSize: 18,
                      fontWeight: 500,
                      color: "#2E2E2E",
                    }}
                  >
                    <img
                      src={bulletIcon}
                      alt="bullet"
                      style={{
                        width: "20px",
                        height: "20px",
                        marginRight: "10px",
                        flexShrink: 0,
                      }}
                    />
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            {/* Right Column (Image) */}
            <div>
              <img
                src={SponsorImage}
                alt="Sponsors Abroad"
                style={{
                  width: "100%",
                  height: 360,
                  borderRadius: "12px",
                  objectFit: "cover",
                }}
              />
            </div>
          </div>
        </div>

        {/* right content */}
        <div
          style={{
            width: "30%",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          {/* All Services */}
          <div
            style={{
              background: "transparent",
              borderRadius: "12px",
              padding: "15px",
              border: "1px solid #2E2E2E4D",
            }}
          >
            <p
              style={{
                fontSize: 18,
                fontWeight: 600,
                color: "#007F5F",
                marginBottom: "16px",
              }}
            >
              All Services
            </p>
            <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
              {servicesList.map((s) => (
                <li
                  key={s.id}
                  onClick={() => navigate(`/services/${s.id}`)}
                  style={{
                    padding: "10px 12px",
                    borderBottom: "1px solid #2E2E2E4D",
                    fontSize: 15,
                    cursor: "pointer",
                    color: s.id === service.id ? "#004E89" : "#2E2E2E",
                    fontWeight: s.id === service.id ? 600 : 400,
                  }}
                >
                  {"→ "}
                  {s.title}
                </li>
              ))}
            </ul>
          </div>

          {/* Need Help Card */}
          <div
            style={{
              background: "linear-gradient(180deg, #007F5F, #00E5AB)",
              borderRadius: 12,
              padding: "18px 16px",
              color: "#fff",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <p
              style={{
                fontSize: 20,
                fontWeight: 600,
                margin: 0,
                marginBottom: "12px",
              }}
            >
              Need Help? Call Us
            </p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                background: "#fff2",
                borderRadius: "8px",
                padding: "8px 16px",
              }}
            >
              <img
                src={phoneIcon}
                alt="phone"
                style={{ width: 20, height: 20 }}
              />
              <span style={{ fontSize: 18, fontWeight: 600, color: "#fff" }}>
                6662 7676
              </span>
            </div>
          </div>

          {/* Follow Us */}
          <div
            style={{
              background: "linear-gradient(180deg, #004E89, #056DBC)",
              borderRadius: "12px",
              padding: "18px",
              color: "#fff",
            }}
          >
            <p
              style={{
                fontSize: 18,
                fontWeight: 600,
                margin: 0,
                marginBottom: "16px",
              }}
            >
              Follow Us
            </p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 12,
              }}
            >
              {socialLinks.map((link, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 36,
                    width: 36,
                    border: "1.5px solid white",
                    borderRadius: "50%",
                    cursor: "pointer",
                  }}
                >
                  <img
                    src={link.icon}
                    alt="social"
                    style={{ width: 18, height: 18 }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <AppointmentForm />
    </div>
  );
}
